import { put } from "src/common/apiClient";
import { getConfig } from "src/apiConfig";
import { TOGGLE_MESSAGE_COLLAPSED } from "src/common/constants";

export function toggleMessageCollapsedPref(params) {
  const url = getConfig(TOGGLE_MESSAGE_COLLAPSED).url;
  const finalUrl = `${url}?CompanyFeatureID=${params.companyFeatureId}&isCollapsed=${params.isCollapsed}`;
  return put({
    url: finalUrl,
  });
}
